var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeNew = function SvgIconBadgeNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13 45.398.836l-2.88 8.566 7.022 6.888S21.437 23.805 4.14 28.455L0 13Z",
    fill: "url(#icon-badge-new_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.1 11.473 2.208 8.24-1.698.455-4.791-4.636 1.48 5.524-1.697.455-2.21-8.24 1.699-.456 4.798 4.64-1.482-5.529 1.692-.453Zm8.86 5.038.355 1.324-4.387 1.176-.354-1.325 4.386-1.175Zm-5.686-5.89 2.21 8.241-1.699.455-2.209-8.24 1.698-.455Zm4.16 2.483.346 1.29-3.815 1.023-.346-1.29 3.815-1.023ZM26.1 9.596l.357 1.33-4.38 1.174-.357-1.33 4.38-1.174Zm4.841 6.134-.217-7.373.917-.246.519 1.098.15 7.555-.984.264-.385-1.298ZM28.24 9.023l3.216 6.569.238 1.337-1.098.295-4.037-7.75 1.68-.451Zm6.904 5.55-.509-7.264 1.68-.451.387 8.729-1.098.294-.46-1.308Zm-2.988-6.6 3.519 6.518.297 1.292-.985.264-3.66-6.62-.082-1.21.911-.244Z",
    fill: "#1D0933"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-badge-new_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(165 23.697 11.406) scale(47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E40DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B90D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#952D43",
    stopOpacity: 0
  })))));
};
export default SvgIconBadgeNew;